// Handle project page close button redirect

document.addEventListener("DOMContentLoaded", function () {
  const projectCloseButton = document.getElementById("project-modal-close");

  if (!projectCloseButton) {
    return;
  }

  // Add from_page to URL if it exists in data attribute but not in URL
  if (projectCloseButton.dataset.fromPage) {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("from_page")) {
      const url = new URL(window.location);
      url.searchParams.set("from_page", encodeURIComponent(projectCloseButton.dataset.fromPage));
      window.history.replaceState({}, "", url.toString());
    }
  }

  // Get from_page slug from query params or data attribute
  function getFromPageSlug() {
    const urlParams = new URLSearchParams(window.location.search);
    const fromPageParam = urlParams.get("from_page");

    if (fromPageParam) {
      return decodeURIComponent(fromPageParam);
    }

    // Check data attribute on close button
    if (projectCloseButton.dataset.fromPage) {
      return projectCloseButton.dataset.fromPage;
    }

    return null;
  }

  // Reconstruct full URL from slug
  function getFromPageUrl() {
    const slug = getFromPageSlug();
    if (!slug) {
      return null;
    }

    // Reconstruct URL: origin + /slug/
    const homeUrl = getHomeUrl();
    // Remove trailing slash from homeUrl if present, then add slug
    const baseUrl = homeUrl.replace(/\/$/, "");
    return baseUrl + "/" + slug + "/";
  }

  // Get home URL (fallback)
  function getHomeUrl() {
    const homeUrlElement = document.querySelector("[data-home-url]");
    if (homeUrlElement) {
      return homeUrlElement.dataset.homeUrl;
    }
    return window.location.origin;
  }

  function closeModal() {
    const fromPageUrl = getFromPageUrl();
    console.log("fromPageUrl", fromPageUrl);
    if (fromPageUrl) {
      window.location.assign(fromPageUrl);
    } else {
      const homeUrl = getHomeUrl();
      console.log("homeUrl", homeUrl);
      window.location.assign(homeUrl);
    }
  }

  // ESC key to close modal
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (Alpine.store("slideshowFullscreen")) return;

    closeModal();
  });

  // Handle close button click - redirect to from_page or home
  projectCloseButton.addEventListener("click", function (e) {
    closeModal();
  });
});
